import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import mountScript from "@dcl/ui/esm/utilities/mountScript";
import { VIMEO_SCRIPT_URL } from "./config";
export default /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var vimeoException;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!window.Vimeo) {
            _context.next = 2;
            break;
          }

          return _context.abrupt("return", window.Vimeo);

        case 2:
          _context.prev = 2;
          _context.next = 5;
          return mountScript(VIMEO_SCRIPT_URL);

        case 5:
          _context.next = 12;
          break;

        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](2);
          vimeoException = new Error("Unable to load the Vimeo API: ".concat(_context.t0));
          vimeoException.name = "VimeoLoadError";
          throw vimeoException;

        case 12:
          return _context.abrupt("return", window.Vimeo);

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 7]]);
}));